import { zonedDate, DEFAULT_TIMEZONE } from '../../utils/date-time';
import moment from 'moment-timezone';

const RECIPIENT_STATUS: Record<string, { label: string; tone: string; order: number }> = {
    AGENDOU: { label: 'Agendou', tone: 'green', order: 0 },
    ABRIU_FLUXO: { label: 'Abriu a oferta', tone: 'blue', order: 1 },
    INDISPONIVEL: { label: 'Sem vaga ao tentar', tone: 'orange', order: 2 },
    ENVIADO: { label: 'Enviada', tone: 'gray', order: 3 },
    PENDENTE_ENVIO: { label: 'Envio pendente', tone: 'gray', order: 4 },
    SEM_INTERESSE: { label: 'Sem interesse', tone: 'gray', order: 5 },
    FALHA_ENVIO: { label: 'Falha no envio', tone: 'red', order: 6 },
};

// `responseStatus` nasce como PENDENTE: sem resposta, o que vale e a situacao do envio.
export const getRecipientStatus = (recipient: any) => {
    const sendStatus = String(recipient?.sendStatus || '').toUpperCase();
    const responseStatus = String(recipient?.responseStatus || '').toUpperCase();
    const key =
        sendStatus === 'FALHA_ENVIO' || !responseStatus || responseStatus === 'PENDENTE'
            ? sendStatus || 'PENDENTE_ENVIO'
            : responseStatus;

    return RECIPIENT_STATUS[key] || { label: key, tone: 'gray', order: 7 };
};

export const sortRecipients = (recipients: any[]) =>
    [...recipients].sort((a, b) => getRecipientStatus(a).order - getRecipientStatus(b).order);

export const getRecipientName = (recipient: any) =>
    String(recipient?.client?.displayName || '').trim() ||
    String(recipient?.client?.phoneNumber || '').trim() ||
    'Cliente';

export const formatMinutes = (minutes: number) => moment.utc().startOf('day').add(minutes, 'minutes').format('HH:mm');

export const formatOfferRange = (offer: any) => {
    const start = Number(offer?.startMinutes);
    const end = Number(offer?.endMinutes);

    return Number.isFinite(start) && Number.isFinite(end) ? `${formatMinutes(start)} às ${formatMinutes(end)}` : 'Oferta';
};

export const formatOfferDay = (date: string | Date, timezone?: string) => {
    const day = zonedDate(date, timezone).startOf('day');
    const today = zonedDate(new Date(), timezone).startOf('day');

    if (day.isSame(today)) return 'Hoje';
    if (day.isSame(today.clone().subtract(1, 'day'))) return 'Ontem';
    if (day.isSame(today.clone().add(1, 'day'))) return 'Amanhã';

    const label = day.format(day.year() === today.year() ? 'ddd, DD [de] MMMM' : 'ddd, DD/MM/YYYY');
    return label.charAt(0).toUpperCase() + label.slice(1);
};

// A oferta encerra quando a faixa passa, mesmo que o status salvo ainda nao tenha mudado.
export const getOfferStatus = (offer: any) => {
    const status = String(offer?.status || '').toUpperCase();

    if (status === 'CANCELADA') return { label: 'Cancelada', tone: 'gray' };
    if (status === 'OCUPADA') return { label: 'Preenchida', tone: 'green' };

    const timezone = offer?.timezone || DEFAULT_TIMEZONE;
    const dateKey = zonedDate(offer?.date, timezone).format('YYYY-MM-DD');
    const wallEnd = moment.utc(dateKey).add(Number(offer?.endMinutes || 0), 'minutes').format('YYYY-MM-DD HH:mm');
    const end = offer?.windowEndAt ? moment(offer.windowEndAt) : moment.tz(wallEnd, 'YYYY-MM-DD HH:mm', true, timezone);
    if (status === 'EXPIRADA' || end.isBefore(moment())) return { label: 'Encerrada', tone: 'gray' };

    return status === 'PARCIALMENTE_OCUPADA'
        ? { label: 'Parcialmente preenchida', tone: 'blue' }
        : { label: 'Ativa', tone: 'blue' };
};

export const formatOfferCurrency = (value?: number) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value || 0));
